import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-32 pb-16 md:pt-40 md:pb-24 px-4 bg-cream relative overflow-hidden" data-id="element-94">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-95">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-sage-light/10 blur-3xl" data-id="element-96"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-gold/10 blur-3xl" data-id="element-97"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-98">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-99">
          <div className="flex-1 text-center lg:text-left" data-id="element-100">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-brown" data-id="element-101">
              How To Reclaim Your Energy, Your Focus, And Your Identity In Just
              90 Days Without Missing A Single Moment Of Your Motherhood...
            </h1>

            <p className="text-xl md:text-2xl font-heading italic text-brown-light mb-8 border-l-4 border-sage pl-6 py-2" data-id="element-102">
              "—Even If You Feel Like 'Mom-Brain' Has Taken Over And You Don't
              Have 5 Minutes To Yourself."
            </p>

            <p className="text-lg md:text-xl text-brown-light mb-10 leading-relaxed" data-id="element-103">
              Stop 'surviving' postpartum. It's time to leave behind the brain
              fog, chronic fatigue, and identity loss to become the radiant
              mother (and woman) your family deserves.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-104">
              <CTAButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-105">
                YES, I WANT TO RECLAIM MY IDENTITY
              </CTAButton>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-106">
            <div className="relative rounded-2xl overflow-hidden shadow-warm-lg transform lg:rotate-2 transition-transform hover:rotate-0 duration-500" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/bKdZw3kR2iGBMUxAGnbzPt/The_Woman_90_Day_Protocol_-_Cover.png" alt="The Woman 90 Day Protocol Cover" className="w-full h-auto object-cover" data-id="element-108" />
              <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent pointer-events-none" data-id="element-109"></div>
            </div>
            {/* Decorative dots */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[radial-gradient(#C9A96E_2px,transparent_2px)] [background-size:12px_12px] opacity-40 -z-10" data-id="element-110"></div>
          </div>
        </div>
      </div>
    </section>;
}